import styled from "styled-components";

export const TextFieldInput = styled.input`
    height: 36px;
    box-sizing: border-box;
    background-color: transparent;
    border: 0;
    outline: 0;
    padding: 0;
    width: 0;
    flex: 1;
`;
